import DefaultSkeleton from "components/DefaultSkeleton";
import { useSession } from "store/Session";
import { useRouter } from "next/router";
import { useEffect } from "react";
import routes from "routes";
import { useDialogs } from "store/Dialogs";
import ConfirmProfile from "components/Dialogs/ConfirmProfile";

const withNoAuthentication = (Component) => {
  const ProtectedRoute = (props) => {
    const { isLoggedIn, data } = useSession();
    const dialogs = useDialogs();
    const router = useRouter();
    const session = useSession();

    useEffect(() => {
      if (router.isReady) {
        if (isLoggedIn === true) {
          const { redirect } = router.query;
          const storedRedirect = localStorage.getItem("storedRedirect");
          localStorage.removeItem("storedRedirect");
          const justSignUp = data.user.createdAt === data.user.updatedAt;
          if (justSignUp) {
            const dialog = dialogs.create({
              DialogType: ConfirmProfile,
              callback: async () => {
                await session.refresh();
                dialog.close();
                router.replace(redirect || storedRedirect || routes.INDEX);
              },
            });
          } else {
            router.replace(redirect || storedRedirect || routes.INDEX);
          }
        }
      }
    }, [isLoggedIn, router]);
  
    if (isLoggedIn === null) return <DefaultSkeleton />;
    return <Component {...props} />;
  };
  return ProtectedRoute;
};

export default withNoAuthentication;
